import React from 'react';
import { Container } from './Container';
import { heroImage } from '../data/content';
export function Hero() {
  return <header className="relative overflow-hidden bg-paper pb-10 pt-10 sm:pt-14 lg:pb-16 lg:pt-16" data-id="element-98" data-mp="ej4lxsz4c3dc">
      <Container className="relative" data-id="element-99" data-mp="9ll9mylze0o1">
        <div className="mx-auto max-w-[880px] text-center" data-id="element-100" data-mp="9igwhbqjful8">
          <h1 className="font-display text-[34px] font-extrabold leading-[0.98] tracking-[-0.015em] text-ink sm:text-[52px] lg:text-[62px]" data-id="element-101" data-mp="4n1k6o86i6qx">
            Turn your child’s screen time into{' '}
            <span className="pop-blue" data-id="element-102" data-mp="xbfi73z9p32h">hours of creativity</span> and fun with{' '}
            <span className="pop-orange" data-id="element-103" data-mp="sai5h6x1118d">1,200+ 3D paper toys</span> ready to build.
          </h1>

          <p className="mx-auto mt-6 max-w-[540px] text-[16px] font-bold leading-[1.4] text-muted sm:text-[19px]" data-id="element-104" data-mp="nczt16jsw3vm">
            Print at home. Cut, fold and build. A brand-new toy whenever boredom hits.
          </p>
        </div>
      </Container>

      {/* LARGE PRODUCT VISUAL */}
      <Container className="relative mt-8 sm:mt-11" data-id="element-105" data-mp="3j8sfs1yzrlqd">
        <figure data-id="element-106" data-mp="3j9ai9gc8yw6q">
          <img src={heroImage.src} alt={heroImage.alt} className="mx-auto block w-full max-w-[720px] object-contain" data-id="element-107" data-mp="3j6obvk13emq3" />

          <figcaption className="mt-2 sm:mt-4" data-id="element-108" data-mp="399jnddjryf64">
            <ul className="mx-auto flex max-w-[680px] flex-nowrap items-center justify-center gap-x-1.5 sm:gap-x-2.5" data-id="element-109" data-mp="3e9fqlakne2km">
              {['Home printer', 'Printed templates', 'Finished 3D toys'].map((label, index) => <React.Fragment key={label} data-id="element-110" data-mp="3599k48nda2uy" data-mpi={index}>
                  {index > 0 && <li aria-hidden="true" className="flex-none font-display text-[13px] font-bold text-brand sm:text-base" data-id="element-111" data-mp="2qk3lalsfyenl">
                      →
                    </li>}
                  <li className="whitespace-nowrap rounded-full border border-hairline bg-white px-2.5 py-1.5 text-[11px] font-bold text-inkSoft shadow-paper sm:px-4 sm:py-2 sm:text-[15px]" data-id="element-112" data-mp="2hjovb94j8bdr">
                    {label}
                  </li>
                </React.Fragment>)}
            </ul>
          </figcaption>
        </figure>
      </Container>
    </header>;
}